export default "__VITE_ASSET__D98AG8Qy__"